import { radioAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { Checkbox as checkboxTheme } from './Checkbox';
import { Radii, Space } from '../../types';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  group: {
    display: 'flex',
    direction: 'column',
    gap: Space.XS,
  },
  container: {
    ...checkboxTheme.baseStyle?.container,
    top: Space.SPACE_1,
  },
  label: { ...checkboxTheme.baseStyle?.label },
  control: {
    ...checkboxTheme.baseStyle?.control,
    borderRadius: Radii.FULL,
    boxSize: '1.125em',
    _checked: {
      ...checkboxTheme.baseStyle?.control?._checked,
    },
  },
});

const sizes = {
  lg: {
    ...checkboxTheme.sizes?.lg,
    control: {
      ...checkboxTheme.sizes?.lg.control,
    },
    group: {
      ...checkboxTheme.sizes?.lg,
    },
  },
  md: {
    ...checkboxTheme.sizes?.md,
    control: {
      ...checkboxTheme.sizes?.md.control,
    },
    group: {
      ...checkboxTheme.sizes?.md,
    },
  },
  sm: {
    ...checkboxTheme.sizes?.sm,
    control: {
      ...checkboxTheme.sizes?.sm.control,
    },
    group: {
      ...checkboxTheme.sizes?.sm,
    },
  },
  xs: {
    ...checkboxTheme.sizes?.xs,
    control: {
      ...checkboxTheme.sizes?.xs.control,
    },
    group: {
      ...checkboxTheme.sizes?.xs,
    },
  },
};

export const Radio = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: checkboxTheme.variants,
  defaultProps: checkboxTheme.defaultProps,
});
